import { call, delay, put, takeLatest } from "redux-saga/effects";

import { startLoader, stopLoader } from "../../../../utils/commonFunctions";

// for toast
import { toast } from "react-toastify";

import { TatActionTypes, TatActions } from "../../../actionTypes/master/tatActionTypes";
import { editTatDataByIdApi, getTatDataByIdApi, getTatListApi } from "../../requests/master/tatRequests";
import { setPutApiStatus } from "../../../actions/apiStatusActions";
import { getTatList, setTatDataById, setTatList, setTatListPageCount } from "../../../actions/master/tatActions";


function* getTatListHandler(action: TatActionTypes) {
  yield delay(500); //to hit search api after 500ms of the last key stroke
  try {
    yield startLoader("transparent");
    const { data } = yield call(getTatListApi, action.payload);
    if (data.status) {
      yield put(setTatList(data?.data?.rows));
      yield put(setTatListPageCount(data?.data?.count ?? 0));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

// function* createTatHandler(action: TatActionTypes) {
//   try {
//     yield startLoader("transparent");
//     const { data } = yield call(createTatApi, action.payload);

//     if (data.status) {
//       // toast message
//       toast.success(data?.message, {
//         position: "top-right",
//       });
//       yield put(setPostApiStatus(true));
//     }
//   } catch (error: any) {
//     toast.error(error?.response?.data?.message, {
//       position: "top-right",
//     });
//     yield put(setPostApiStatus(false));
//   } finally {
//     yield stopLoader("transparent");
//   }
// }

function* getTatDataByIdHandler(action: TatActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(getTatDataByIdApi, action.payload);
    if (data.status) {
      yield put(setTatDataById(data?.data));
    } else {
      toast.error(data?.message, {
        position: "top-right",
      });
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}
function* editTatDataByIdHandler(action: TatActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(editTatDataByIdApi, action.payload);
    if (data.status) {
      toast.success(data.message, {
        position: "top-right",
      });
      yield put(setPutApiStatus(true));
      yield put(getTatList({ page: 0, pageLimit: 10 }));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPutApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

// tat sagas
export default function* tatSaga() {
  // yield takeLatest(TatActions.CREATE_TAT, createTatHandler);
  yield takeLatest(TatActions.GET_TAT_LIST, getTatListHandler);
  yield takeLatest(TatActions.GET_TAT_DATA_BY_ID, getTatDataByIdHandler);
  yield takeLatest(TatActions.EDIT_TAT_DATA_BY_ID, editTatDataByIdHandler);
}
